import { useEffect, useState } from "react";
import { useAnnouncementFlagsQuery } from "hooks/queries";
import { MaintenanceAnnouncement } from "./MaintenanceAnnouncement";

const ANNOUNCEMENT_MESSAGE_TYPE = "pks:announcement-state";
const ANNOUNCEMENT_REQUEST_TYPE = "pks:announcement-state-request";

const useParentAnnouncementSuppression = (): boolean => {
  const [suppressed, setSuppressed] = useState(false);

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.data?.type === ANNOUNCEMENT_MESSAGE_TYPE) {
        setSuppressed(!!event.data.visible);
      }
    };
    window.addEventListener("message", handler);

    // Request current announcement state from the parent window so that
    // the suppression flag is restored after an iframe page refresh.
    window.parent?.postMessage({ type: ANNOUNCEMENT_REQUEST_TYPE }, "*");
    return () => window.removeEventListener("message", handler);
  }, []);

  return suppressed;
};

export const Announcement = () => {
  const { flags } = useAnnouncementFlagsQuery();
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(!!flags.showAnnouncement);
  }, [flags.showAnnouncement]);

  // Suppress announcement when the parent window signals its own announcement is active,
  // to avoid showing duplicate banners when embedded in pokerskins-website.
  const parentAnnouncementSuppressed = useParentAnnouncementSuppression();
  const shouldShow = show && !parentAnnouncementSuppressed;

  return shouldShow ? (
    <MaintenanceAnnouncement
      announcement={flags.announcementMessage || ""}
      onClose={() => {
        setShow(false);
      }}
    ></MaintenanceAnnouncement>
  ) : null;
};
